import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'
import { useNavigate, useNavigation } from 'react-router-dom';
import { Deletedata, getBlob, getData, patchData, postBlob, Postdata, Postdataform, PostFileData, updateData } from '../../../API/GlobalApi.js';
import { handlePaginate } from '../../../Utils/handlePagination.js';

import { v4 as uuidv4 } from "uuid";
import ConfirmationModal from '../../../Component/Modals/ConfirmationModal.js';
import SpinnerLoader from '../../../Utils/Spinner.js';
import SearchingBar from '../../../Utils/Searching.js';
import Notifier from '../../../Utils/notify.js';
import OtpModal from '../../../Component/Modals/DiscountOtpInput.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import DiscountNotice from '../../../Component/Modals/DiscountNoticePrint.js';
import { useHasPermission } from '../../../Utils/checkPermissions.js';
import { generateDiscountPDFDashboard } from '../../../Utils/generatePdfForTemplateSent.js';

import { WaitFeeApprovalsModal } from '../../../Component/Modals/WaitApprovalForFeeTemplate.js';


const ManageDiscounts = () => {



    const [isLoading, setIsLoading] = useState(true);
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [filtermodal, setfiltermodal] = useState(false);
    const handleFilterClick = () => {
        setfiltermodal(true);
    };
    const [selectedDiscount, setSelectedDiscount] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPageStudent, setCurrentPageStudent] = useState(0);
    const [totalCountStudent, setTotalCountStudent] = useState(0);
    const [discountFeeData, setDiscountFeeData] = useState([])
    const [modalMode, setModalMode] = useState('create');
    const [filterDiscount, setFilterDiscount] = useState([])
    const [filterStudent, setFilterStudent] = useState([])
    const [filterQueryString, setFilterQueryString] = useState('');
    const navigate = useNavigate();
    const pageSize = 10;
    const pageCounts = Math.ceil(totalCount / pageSize);
    const pageSizeDiscountStudent = 10
    const pageCountsStudent = Math.ceil(totalCountStudent / pageSizeDiscountStudent);
    const [filterLoading, setFilterLoading] = useState(false);
    const [defaultStudents, setDefaultStudents] = useState([]);
    const [showWaittingModal, setShowWaitingModal] = useState(false)


    const hasPermission = useHasPermission();


    const getDicountedData = async (page = 0, studentPage = 1, studentPageSize = 10) => {
        const pageNumber = page + 1;

        const url = filterQueryString
            ? `finance/academic-group-fee-discounts/?${filterQueryString}&page=${pageNumber}&students_page=${studentPage}&students_page_size=${studentPageSize}`
            : `finance/academic-group-fee-discounts/?page=${pageNumber}&students_page=${studentPage}&students_page_size=${studentPageSize}`;

        if (isInitialLoad) setIsLoading(true);
        else setSearchLoading(true);

        try {
            const response = await getData(url);

            const data = response?.results || [];
            const count = response?.count || 0;

            setDiscountFeeData(data);
            setFilterDiscount(data);
            setTotalCount(count);
            if (data.length > 0) {
                const firstFeeHead = data[0]?.fee_heads?.[0];
                setTotalCountStudent(firstFeeHead?.students_pagination?.total_count || 0);
            }


        } catch (error) {
            Notifier.error(error);
            setDiscountFeeData([]);
            setTotalCount(0);
        } finally {
            if (isInitialLoad) {
                setIsLoading(false);
                setIsInitialLoad(false);
            } else {
                setSearchLoading(false);
            }
            setFilterLoading(false);
        }
    };


    const [selectedStudents, setSelectedStudents] = useState([]);

    useEffect(() => {
        if (discountFeeData.length > 0) {
            // Pick first discount group as default
            const firstGroupStudents = discountFeeData[0]?.fee_heads?.flatMap(head => head.students || []) || [];
            setDefaultStudents(firstGroupStudents);
            setSelectedStudents(firstGroupStudents);
        }
    }, [discountFeeData]);

    useEffect(() => {
        getDicountedData(currentPage);
    }, [currentPage, filterQueryString]);



    const handleRowClick = async (id, row) => {
        setCurrentPageStudent(0);
        const students = row.original?.students || [];

        if (students.length > 0) {
            const res = await getData(`finance/academic-group-fee-discount-students/?unique_id=${students[0]?.unique_id}`)
            setSelectedStudents(res?.students);
            setTotalCountStudent(res?.pagination?.total_count)
            setDiscountUniqueId(selectedStudents[0]?.unique_id)
        } else {
            // If no students in this discount, fallback to default
            setSelectedStudents(defaultStudents);
        }
    };




    const handleRowClickStudent = async (id, row) => {
        try {

        } catch (error) {

        }
    };

    const [selectedRows, setSelectedRows] = useState([]);
    const handleSelectionChange = (row) => {
        setSelectedRows(prev => {
            const exists = prev.some(r => r.id === row.id);
            if (exists) {
                return prev.filter(r => r.id !== row.id);
            } else {
                return [...prev, row];
            }
        });
    };




    const sourceData = useMemo(() => {
        return filterQueryString ? filterDiscount : discountFeeData;
    }, [discountFeeData, filterDiscount, filterQueryString]);



    const formattedData = useMemo(() => {
        return sourceData?.map((fee) => ({
            id: `${fee?.discount_id || "disc"}-${fee?.fee_heads?.[0]?.students?.[0]?.unique_id}`,
            academic_group_name: fee.academic_group_name,
            unique_id: fee?.fee_heads?.[0]?.students?.[0]?.unique_id,
            total_discount_amount: fee?.total_discount_amount,
            academic_year: fee?.academic_year,
            is_verified: fee.is_verified,
            total_students: fee?.total_students,
            students: fee.fee_heads?.flatMap(head => head?.students || []) || [], // ✅ merge all students
            handleRowClick, // for table row action
        }));
    }, [sourceData]);

    const formattedStudents = useMemo(() => {
        return selectedStudents?.map((student) => ({
            id: `${student.discount_id}-${student.student_id}`,
            fee_head: student.fee_head || "-",
            student_name: student.student_name || "-",
            unique_id: student.unique_id,
            discount_id: student.discount_id,
            student_course_name: student.student_course_name || "-",
            registration_number: student.registration_number || 0,
            discount: student.discount,
            created_at: student.created_at,
            approved_by_employee: student.approved_by_employee,
            fee_head_amount: student.fee_head_amount,
            fee_head: student.fee_head,
            handleRowClickStudent
        })) || [];
    }, [selectedStudents]);




    const searchInputRef = useRef(null);
    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);





    const [studentResponse, setStudentResponse] = useState('')

    const [discountUniqueId, setDiscountUniqueId] = useState('')
    const [feePlanData, setFeePlanData] = useState(null);

    const getStudentDataBasedOnUniqueId = async (uniqueId) => {
        if (!uniqueId) return;

        try {
            const res = await getData(`finance/academic-group-fee-discounts-by-unique-id/?unique_id=${uniqueId}`);

            if (!res?.data || !res.data.length) {
                setFeePlanData(null);
                return;
            }

            const groupData = res.data[0];
            const mappedData = {
                full_course_name: groupData.academic_group_name,
                academic_year: groupData.academic_year,
                total_students: groupData.total_students || groupData.fee_heads?.[0]?.student_count || 0,
                total_discount_amount: groupData.total_discount_amount || 0,
                fee_head_names: groupData.fee_heads.map(fh => fh.fee_head_name),
                created_by: groupData.fee_heads.flatMap(fh => fh.students || [])?.[0]?.created_by || "N/A",
                students: groupData.fee_heads.flatMap(fh =>
                    (fh.students || []).map(stu => ({
                        student_name: stu.student_name,
                        registration_number: stu.registration_number || "N/A",
                        fee_head_name: fh.fee_head_name,
                        discount_amount: stu.discount,
                        discount: stu.discount,
                        approved_by_employee: stu.approved_by_employee
                    }))
                )
            };


            setFeePlanData(mappedData);

        } catch (err) {
            console.error(err);
        }
    };


    useEffect(() => {
        getStudentDataBasedOnUniqueId(discountUniqueId)
    }, [discountUniqueId])

    const handlesResendOtpToAssignedPerson = async (employeeIds = []) => {



        const url = 'finance/resend-discount-otp/';


        const uniqueFileName = uuidv4().replace(/-/g, "").slice(0, 20);
        const pdfBlob = generateDiscountPDFDashboard(
            feePlanData,         // previewData 
            selectedDetails.academic_year // selectedSessionName
        );

        const approvalUrl = `${process.env.REACT_APP_WINDOW_BASEURL2}fee/discount-approvals/${selectedStudents[0]?.unique_id}`;
        const formData = new FormData();

        formData.append("document_url", pdfBlob, `discount_${selectedStudents[0]?.unique_id}.pdf`);


        const payload = {
            unique_id: selectedStudents[0]?.unique_id,
            employee_ids: employeeIds.join(','),
            document_uuid: uniqueFileName,
            approval_url: approvalUrl
        };

        Object.entries(payload).forEach(([key, value]) => {
            if (typeof value === "object" && value !== null) {
                formData.append(key, JSON.stringify(value));
            } else {
                formData.append(key, value);
            }
        });

        try {
            const response = await Postdataform(url, formData);
            if (!response?.error) {
                setStudentResponse({ otp: response.otp, signed_urls: response.signed_urls })
                Notifier.success("Approval message sent successfully to the assigned person!");
                setShowWaitingModal(true);
                setOtpModalOpen(false)

            } else {
                Notifier.error(response.error || "Failed to resend OTP.");
            }
        } catch (error) {

            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        }
    };

    const [helpdeskperson, setHelpDeskPerson] = useState([]);

    const gethelpdeskPerson = async () => {
        try {
            const url = "finance/course-fee-plans/authorized-employees/?type=discount";
            const response = await getData(url);

            if (response?.authorized_employees?.length) {

                setHelpDeskPerson(response.authorized_employees);

                // Map API data to react-select format
                // const options = response.authorized_employees.map((emp) => ({
                //     value: emp.id,
                //     label: `${emp.name} (${emp.employee_code})`
                // }));

                // setEmployeeOptions(options);
            }
        } catch (error) {
            console.error("Error fetching authorized employees:", error);
        }
    };
    useEffect(() => {
        gethelpdeskPerson()
    }, [])


    const [selectedDetails, setSelectedDetails] = useState([]);
    const handelSendOtp = (row) => {
        setSelectedDetails(row?.original)
        setOtpModalOpen(true);
    };




    const [otpModalOpen, setOtpModalOpen] = useState(false);
    const [otpModalKey, setOtpModalKey] = useState(0);

    const handleConfirmOtp = async (otpCode) => {
        const url = 'finance/verify-discount-otp/';
        const payload = {
            unique_id: selectedStudents[0]?.unique_id,
            otp: otpCode
        };

        try {
            const response = await Postdata(url, payload);
            if (!response?.error) {
                Notifier.success("Discount approve successfully");
                // setHelpDeskPerson([])
                setStudentResponse('')
                setOtpModalOpen(false);
                setOtpModalKey(prev => prev + 1);
                getDicountedData(currentPage);
            } else {
                // ✅ use error if message not present
                const errMsg = response.error || response.message || "Failed to verify OTP.";
                Notifier.error(errMsg);
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);

            const errorMessage =
                error?.response?.data?.message ||
                error?.response?.data?.error ||   // ✅ backend may return error key
                error?.message ||
                "Something went wrong. Please try again.";
            Notifier.error(errorMessage);
        }
    };

    // Step 5: Cancel OTP modal
    const handleCancelOtp = () => {
        setOtpModalOpen(false);
        setOtpModalKey(prev => prev + 1);
        setStudentResponse('')
    };


    const columns = useMemo(
        () => [

            {
                Header: "Course",
                accessor: 'academic_group_name',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }}
                        // onClick={() => {
                        //   navigate(`/studentDashboard/StudentFullProfile/${row.original.id}`);
                        // }}
                        onClick={() => handleRowClick(row.original.id, row)}                     >
                        <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.academic_group_name}
                        </p>


                    </div>
                ),
            },
            {
                Header: "Admission Academic Year",
                accessor: 'academic_year',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }}
                    >
                        <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.academic_year}
                        </p>


                    </div>
                ),
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Unique Id</p>,
                accessor: 'unique_id',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div className="no-text-cursor">
                        <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.unique_id}</p>
                    </div>
                )
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Total Student</p>,
                accessor: 'total_students',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div className="no-text-cursor" >
                        <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.total_students}</p>
                    </div>
                )
            },


            {
                Header: () => <p style={{ textAlign: 'right' }}>Amount</p>,
                accessor: 'total_discount_amount',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: 'right', color: '#222F3E', margin: 0 }} className="no-text-cursor">
                        ₹{row.original.total_discount_amount?.toFixed(2)}
                    </div>
                )
            },



            {
                Header: "Status",
                accessor: "is_verified",
                disableSortBy: true,
                Cell: ({ value }) => (
                    <span className="no-text-cursor"
                        style={{
                            color: value ? "green" : "orange",
                            fontWeight: "500"
                        }}
                    >
                        {value ? "Approved" : "Pending"}
                    </span>
                )
            },
            {
                Header: 'Action',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const { is_verified } = row.original;
                    return (
                        <div>



                            {!is_verified && (<svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                width="24"
                                height="24"
                                fill="#7F56DA"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handelSendOtp(row)}

                            ><title>Send OTP</title>
                                <path d="M458.5 112H265V62.4A31.4 31.4 0 0 0 233.6 31H62.4A31.4 31.4 0 0 0 31 62.4v387.2A31.4 31.4 0 0 0 62.4 481h171.2A31.4 31.4 0 0 0 265 449.6V292h193.5A22.5 22.5 0 0 0 481 269.5V134.5A22.5 22.5 0 0 0 458.5 112ZM125.5 50.1h45a11.3 11.3 0 0 1 0 22.5h-45a11.3 11.3 0 0 1 0-22.5Zm45 411.8h-45a11.3 11.3 0 1 1 0-22.5h45a11.3 11.3 0 0 1 0 22.5Zm74.7-41.6H50.8V91.8h194.4V112H125.3a22.3 22.3 0 0 0-22.3 22.3V269.7a22.3 22.3 0 0 0 22.3 22.3H166v36.1a11.1 11.1 0 0 0 19 7.9L229 292h16.2ZM220.8 210.2a11.3 11.3 0 0 1-11.3 19.5L195.3 221.4V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4L161.5 202l-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM328.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM436.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3Z" />
                            </svg>)}
                        </div>

                    );
                }
            }


        ],
        []
    );

    const columnStudent = useMemo(() => {
        const baseColumns = [
            {
                Header: "Student Name",
                accessor: 'student_name',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleRowClickStudent(row.original.id, row)}
                    >
                        <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>
                            {row.original.student_name}
                        </p>
                    </div>
                ),
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Fee Head</p>,
                accessor: 'fee_head',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div className="no-text-cursor">
                        <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.fee_head}</p>
                    </div>
                )
            },
            {
                Header: () => <p style={{ textAlign: 'left' }}>Registration Number</p>,
                accessor: 'registration_number',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div className="no-text-cursor">
                        <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>{row.original.registration_number}</p>
                    </div>
                )
            },
            {
                Header: () => <p style={{ textAlign: 'right' }}>Discount Amount</p>,
                accessor: 'discount',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: 'right', color: '#222F3E', margin: 0 }} className="no-text-cursor">
                        ₹ {row.original.discount}
                    </div>
                )
            },
        ];

        // 👉 Only add Action column if ANY student is_verified === true
        const hasVerified = selectedStudents?.some(s => s.is_verified === true);

        if (hasVerified) {
            baseColumns.push({
                Header: 'Action',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#7F56DA"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handlePrintNotice(row)}
                                data-tooltip-id="admission-tip"
                                data-tooltip-content="Print Notice"
                            >
                                <path d="M6 9V2h12v7" />
                                <path d="M6 18H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2" />
                                <rect x="6" y="14" width="12" height="8" />
                                <title>Print Notice</title>
                            </svg>
                        </div>
                    </div>
                )
            });
        }

        return baseColumns;
    }, [selectedStudents]); // dependency added


    const handleSetSearchResults = (data) => {
        setFilterDiscount(Array.isArray(data) ? data : []);
    };


    const handlePageChange = ({ selected }) => {

        setCurrentPage(selected);
        handlePaginate({
            selectedPage: selected,
            url: 'finance/academic-group-fee-discounts/',
            filterQueryString,
            setResults: handleSetSearchResults,
            setTotalCount,
            setFilterQueryString,
        });
    }


    const handlePageChangeStudent = async ({ selected }) => {
        setCurrentPageStudent(selected);
        const uniqueId = selectedStudents?.[0]?.unique_id;
        if (!uniqueId) return;
        const res = await getData(
            `finance/academic-group-fee-discount-students/?unique_id=${uniqueId}&students_page=${selected + 1}&students_page_size=10`
        );
        setSelectedStudents(res?.students || []);
        setTotalCountStudent(res?.pagination?.total_count || 0);
    };





    const [showConfirmationDelteModal, setShowConfirmDeleteModal] = useState(false)
    const [showPrintNoticeModal, setShowPrintNoticeModal] = useState(false);
    const [showDiscountPrintNoticeModal, setShowDiscountPrintNoticeModal] = useState(false);
    const [selectedCourseStudents, setSelectedCourseStudents] = useState([]);
    const [selectedFeeId, setSelectedFeeId] = useState(null);


    const handleDeleteFee = (row) => {
        setSelectedFeeId(row.original.id);
        setShowConfirmDeleteModal(true)
    }


    // On confirm
    const handleDelteConfirmYes = async () => {
        if (!selectedFeeId) return;

        try {
            const res = await Deletedata(`finance/delete-course-fee-schedule/${selectedFeeId}/`);

            if (res?.success || res?.status === 204) {
                Notifier.success('Schedule Fee Deleted successfully');
                getDicountedData(); // refresh table
            } else {
                Notifier.error('Failed to delete Schedule Fee');
            }
        } catch (error) {

            Notifier.error('An error occurred while deleting Schedule Fee');
        } finally {
            setShowConfirmDeleteModal(false);
            setSelectedFeeId(null);
        }
    };

    const handleDelteConfirmNo = () => {
        setShowConfirmDeleteModal(false)

    }

    const handlePrintNotice = (row) => {

        setSelectedCourseStudents(row.original || []);
        setShowDiscountPrintNoticeModal(true);
    }










    return (
        <>
            {isLoading ? (
                <SpinnerLoader />
            ) : (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100vh",
                    overflow: "hidden",
                    position: "relative",
                }}>

                    {/* ── FIXED: Title ── */}
                    <div style={{ flexShrink: 0, padding: "0 12px" }}>
                        <h2 className="main-heading">Manage Discounts</h2>
                    </div>

                    {/* ── FIXED: Search + Add Button ── */}
                    <div style={{ flexShrink: 0, padding: "8px 12px" }}>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", alignItems: "center" }}>
                            <SearchingBar
                                placeholder="Search by Student name, Registration num, Semester, Course...."
                                url="/finance/academic-group-fee-discounts/"
                                filterQueryString={filterQueryString}
                                setResults={handleSetSearchResults}
                                ref={searchInputRef}
                                setTotalCount={setTotalCount}
                                setFilterQueryString={setFilterQueryString}
                                setSearchLoading={setSearchLoading}
                                setCurrentPage={setCurrentPage}
                            />
                            {hasPermission("can-give-discount") && (
                                <button className="add-btn" onClick={() => navigate('/finance/add-discount')} style={{ padding: "10px 25px" }}>
                                    <span className="me-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                            <line x1="16" y1="2" x2="16" y2="6" />
                                            <line x1="8" y1="2" x2="8" y2="6" />
                                            <line x1="3" y1="10" x2="21" y2="10" />
                                            <line x1="12" y1="14" x2="12" y2="20" />
                                            <line x1="9" y1="17" x2="15" y2="17" />
                                        </svg>
                                    </span>
                                    Add discount
                                </button>
                            )}
                        </div>
                    </div>

                    {/* ── SCROLLABLE BOTTOM: Two tables side by side ── */}
                    <div style={{
                        display: "flex",
                        flex: 1,
                        minHeight: 0,
                        overflow: "hidden",
                        padding: "0 12px",
                        gap: "12px",
                        alignItems: "stretch",
                    }}>

                        {/* LEFT: Discounts Table */}
                        <div style={{
                            flex: "0 0 50%",
                            maxWidth: "50%",
                            display: "flex",
                            flexDirection: "column",
                            minHeight: 0,
                            overflow: "hidden",
                        }}>
                            {filterLoading ? (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
                                    <SpinnerLoader />
                                </div>
                            ) : formattedData?.length > 0 ? (
                                <AdvanceTable
                                    columns={columns}
                                    pageCounts={pageCounts}
                                    handlePageChange={handlePageChange}
                                    selectedData={selectedDiscount}
                                    data={formattedData}
                                    handleRowClick={handleRowClick}
                                    currentPage={currentPage}
                                    checkbox={false}
                                    onSelectionChange={handleSelectionChange}
                                />
                            ) : (!isLoading && !isSearchLoading && (
                                <div style={{
                                    display: "flex", flexDirection: "column",
                                    alignItems: "center", justifyContent: "center",
                                    flex: 1, color: "#888", textAlign: "center",
                                }}>
                                    No Discounted Fee available.
                                </div>
                            ))}
                        </div>

                        {/* RIGHT: Students Table */}
                        <div style={{
                            flex: "0 0 50%",
                            maxWidth: "50%",
                            display: "flex",
                            flexDirection: "column",
                            minHeight: 0,
                            overflow: "hidden",
                        }}>
                            {filterLoading ? (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
                                    <SpinnerLoader />
                                </div>
                            ) : formattedStudents?.length > 0 ? (
                                <AdvanceTable
                                    columns={columnStudent}
                                    pageCounts={pageCountsStudent}
                                    handlePageChange={handlePageChangeStudent}
                                    selectedData={selectedStudents}
                                    data={formattedStudents}
                                    handleRowClick={handleRowClickStudent}
                                    currentPage={currentPageStudent}
                                />
                            ) : (!isLoading && !isSearchLoading && (
                                <div style={{
                                    display: "flex", flexDirection: "column",
                                    alignItems: "center", justifyContent: "center",
                                    flex: 1, color: "#888", textAlign: "center",
                                }}>
                                    Students were not given any discount.
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
            <div>
                <ConfirmationModal
                    isOpen={showConfirmationDelteModal}
                    // onClose={() => { setShowConfirmDeleteModal(false) }}
                    onConfirm={handleDelteConfirmYes}
                    onCancel={handleDelteConfirmNo}
                    title="Delete Scheduled Fee"
                    message="Are you sure you want to delete this scheduled fee? This action cannot be undone."
                />


                <DiscountNotice
                    isOpen={showDiscountPrintNoticeModal}
                    students={selectedCourseStudents}
                    onClose={() => setShowDiscountPrintNoticeModal(false)}
                />

                <OtpModal
                    key={otpModalKey}

                    heading={`Please Select person to send the approval message to the assigned person via WhatsApp. `}
                    isOpen={otpModalOpen}
                    onConfirm={handleConfirmOtp}
                    onCancel={handleCancelOtp}
                    onResend={handlesResendOtpToAssignedPerson}
                    studentResponse={studentResponse}
                    employees={helpdeskperson}
                    fromDiscountDashboard={"No need to resend otp"}
                    hideOtpInput={true}
                />

            </div>

            <WaitFeeApprovalsModal isOpen={showWaittingModal}
                // feePlanId={specializationSubmitResponse?.unique_id}
                onClose={() => {
                    setShowWaitingModal(false)
                    // navigate(-1)
                }} />

        </>
    );
};


export default ManageDiscounts